import { Button, Stack, Typography } from "@mui/material";
import I18n from "i18next";
import format from "date-fns/format";

import MzDataGrid from "@markaaz/ui/MzDataGrid";
import MzTooltip from "@markaaz/ui/MzTooltip";
import MzPagination from "@markaaz/ui/MzPagination";
import downloadIcon from "../../../assets/icons/download.svg";
import historyIcon from "../../../assets/icons/history.svg";
import Loading from "components/common/Loading/Loading";
import { trimCharecter } from "utils/helpers";

const sx = {
  root: {
    maxWidth: "1200px",
    h2: {
      color: "#25245F"
    }
  },

  delete: {
    cursor: "pointer"
  },

  datagrid: {
    height: "585px",
    maxWidth: "750px",

    ".menu-icon": {
      color: "blue.c100"
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      borderBottom: "none"
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      borderBottom: (theme) => `1px solid ${theme.palette.lightBlue.c100}`
    },
    "& .hide-header .MuiDataGrid-columnHeaderTitleContainer": {
      display: "none"
    }
  },

  addPortfolioBtn: {
    color: "#0A78CD",
    textTransform: "capitalize",
    textDecoration: "underline",
    paddingLeft: 0,
    fontSize: "14px !important",
    fontWeight: "700"
  },

  errorStatus: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    svg: {
      color: "negative.c100",
      fontSize: "16px"
    }
  }
};

function UsageReport({ rows, pagination, onDownload, onHistoryClick }) {
  const columns = [
    {
      field: "name",
      headerName: I18n.t("reports.reportName"),
      width: 370,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <MzTooltip title={row.name} placement="top" arrow color="Acqua" sx={sx.tooltip}>
            <Typography variant="body2">{trimCharecter(row.name)}</Typography>
          </MzTooltip>
        );
      }
    },
    {
      field: "createdDate",
      headerName: I18n.t("reports.createdDate"),
      width: 130,
      sortable: false,
      valueGetter: function ({ value }) {
        return format(new Date(value), "LL/dd/yyyy");
      }
    },
    {
      field: "createdTime",
      headerName: I18n.t("reports.createdTime"),
      width: 130,
      sortable: false,
      valueGetter: function ({ value }) {
        return format(new Date(value), "p");
      }
    },
    {
      field: "download",
      headerName: "",
      headerClassName: "hide-header",
      width: 60,
      sortable: false,
      renderCell: ({ row }) => (
        <Button size="sm" onClick={() => onDownload(row.partnerReportsId)}>
          <MzTooltip title="Download" placement="top" arrow color="Acqua">
            <img height="25px" src={downloadIcon} alt="downloadIcon" />
          </MzTooltip>
        </Button>
      )
    },
    {
      field: "history",
      headerName: "",
      headerClassName: "hide-header",
      width: 60,
      sortable: false,
      renderCell: ({ row }) => (
        <Button
          onClick={() => {
            onHistoryClick(row);
          }}
          size="sm"
          display="content"
        >
          <MzTooltip title="History" placement="top" arrow color="Acqua">
            <img height="20px" src={historyIcon} alt="historyIcon" />
          </MzTooltip>
        </Button>
      )
    }
  ];

  const hidePagination = rows?.rec_count <= 10;

  return (
    <>
      {!rows?.details ? (
        <Loading />
      ) : (
        <>
          <MzDataGrid
            rowHeight={45}
            headerHeight={42}
            sx={sx.datagrid}
            rows={rows?.details}
            paginationMode="server"
            rowCount={rows?.rec_count}
            columns={columns}
            disableSelectionOnClick
            disableColumnMenu={true}
            autoPageSize
            getRowId={(row) => row.partnerReportsId}
            hideFooterPagination
          />
          {!hidePagination && (
            <Stack alignItems="center" maxWidth={"750px"}>
              <MzPagination count={pagination.count} page={pagination.page} onChange={pagination.onChange} />
            </Stack>
          )}
        </>
      )}
    </>
  );
}

export default UsageReport;
